import { Typography, ListItemButton } from '@mui/material';
import CheckY from '../../../../Assets/Images/CheckY.png';
import CheckN from '../../../../Assets/Images/CheckN.png';
import { useDispatch, useSelector } from 'react-redux';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';

const MAIN_WORK_TYPES = ['WT_001', 'WT_002'];

export default function TypeWork() {
  const baseInfo = useSelector((state) => state.permit.baseInfo);
  const codeList = useSelector((state) => state.permit.codeInfo);
  const dispatch = useDispatch();

  const selectedWorkTypes = Array.isArray(baseInfo.workTypes)
    ? baseInfo.workTypes
    : [];

  const handleToggleWorkType = (item) => {
    const isSelected = selectedWorkTypes.includes(item.workType);
    const isMainType = MAIN_WORK_TYPES.includes(item.workType);

    const resetSubItems = (list, targetItemIds) =>
      (list || []).map((subItem) =>
        targetItemIds.includes(String(subItem.workItemId))
          ? { ...subItem, itemCheck: '' }
          : subItem
      );

    if (isSelected) {
      if (isMainType) {
        // 주 작업 해제 시: 남은 주 작업이 없으면 보조 작업도 함께 해제
        const remainingMainTypes = selectedWorkTypes.filter(
          (t) => t !== item.workType && MAIN_WORK_TYPES.includes(t)
        );
        const hasOtherMain = remainingMainTypes.length > 0;
        const subOnlyTypes = selectedWorkTypes.filter(
          (t) => t !== item.workType && !MAIN_WORK_TYPES.includes(t)
        );

        if (!hasOtherMain && subOnlyTypes.length > 0) {
          // 주 작업이 모두 없어지면 보조 작업도 전부 해제
          const allRemovedItemIds = codeList.workTypes
            .filter(
              (w) =>
                w.workType === item.workType ||
                subOnlyTypes.includes(w.workType)
            )
            .map((w) => String(w.workItemId));

          dispatch(
            PermitActions.setCodeInfo({
              risks: resetSubItems(codeList.risks, allRemovedItemIds),
              equips: resetSubItems(codeList.equips, allRemovedItemIds),
              preparations: resetSubItems(
                codeList.preparations,
                allRemovedItemIds
              ),
            })
          );
          dispatch(
            PermitActions.setBaseInfo({
              workTypes: remainingMainTypes,
              workItemIds: (baseInfo.workItemIds || []).filter((id) => {
                const matchedType = codeList.workTypes.find(
                  (w) => String(w.workItemId) === String(id)
                );
                return matchedType && !allRemovedItemIds.includes(String(id));
              }),
            })
          );
          dispatch(
            showSnackbar({
              message:
                '주 작업 해제로 인해 함께 선택된 보조 작업도 해제되었습니다.',
              type: 'info',
            })
          );
          return;
        }
      }

      // 일반 해제
      const removedItemId = String(item.workItemId);
      dispatch(
        PermitActions.setCodeInfo({
          risks: resetSubItems(codeList.risks, [removedItemId]),
          equips: resetSubItems(codeList.equips, [removedItemId]),
          preparations: resetSubItems(codeList.preparations, [removedItemId]),
        })
      );
      dispatch(
        PermitActions.setBaseInfo({
          workTypes: selectedWorkTypes.filter((t) => t !== item.workType),
          workItemIds: (baseInfo.workItemIds || []).filter(
            (id) => id !== item.workItemId
          ),
        })
      );
    } else {
      // 선택 추가
      if (!isMainType) {
        const hasMain = selectedWorkTypes.some((t) =>
          MAIN_WORK_TYPES.includes(t)
        );
        if (!hasMain) {
          dispatch(
            showSnackbar({
              message: '일반작업 또는 화기작업을 먼저 선택해 주세요.',
              type: 'warning',
            })
          );
          return;
        }
      }
      dispatch(
        PermitActions.setBaseInfo({
          workTypes: [...selectedWorkTypes, item.workType],
          workItemIds: [...(baseInfo.workItemIds || []), item.workItemId],
        })
      );
    }
  };

  return (
    <div>
      <p style={{ fontSize: '16px', color: '#939393' }}>
        일반작업 또는 화기작업을 선택하고 <br /> 필요 시 보조 작업을 추가로
        선택해 주세요.
      </p>

      <div style={{ marginBottom: '16px' }}>
        {codeList?.workTypes && codeList.workTypes.length > 0 ? (
          codeList.workTypes.map((item, index) => {
            const isSelected = selectedWorkTypes.includes(item.workType);

            return (
              <ListItemButton
                key={index}
                sx={{
                  mt: 1.25,
                  p: 2,
                  py: 1.5,
                  gap: 1,
                  border: 1,
                  borderRadius: 2.5,
                  borderColor: isSelected ? '#80CB66' : '#E8E8E8',
                  backgroundColor: isSelected ? '#ECF6E8' : '#fff',
                  '&:focus': {
                    outline: 'none',
                    borderColor: isSelected ? '#80CB66' : '#E8E8E8',
                    backgroundColor: isSelected ? '#ECF6E8' : '#fff',
                  },
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => handleToggleWorkType(item)}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  {item.workTypeNm}
                </Typography>
                <img src={isSelected ? CheckY : CheckN} alt="체크" />
              </ListItemButton>
            );
          })
        ) : (
          <div
            style={{ textAlign: 'center', padding: '20px', color: '#939393' }}
          >
            작업 종류를 불러오는 중...
          </div>
        )}
      </div>
    </div>
  );
}
